import { useEffect, useState } from "react";
import data from "./json.json";
import "./assesment.css";
import { useParams, useNavigate } from "react-router-dom";
import {
  GetInterviewSheet,
  GetConclusionStatus,
  SubmitInterviewSheet,
} from "./InterviewService";
import NormalAlert from "../AlertComponent/NormalAlert";
import { GetInterviewResume } from "./InterviewService";
import { Modal } from "react-bootstrap";

const InterviewAssesment = () => {
  const { InterviewUID } = useParams();

  // const { candidateDetails } = data;
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [responses, setResponses] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [enteredCode, setEnteredCode] = useState("");
  const [candidateDetails, setCandidateDetails] = useState(null);
  const [jobDetails, setjobDetails] = useState(null);
  const [interviewerDetails, setinterviewerDetails] = useState(null);
  const [alert, setAlert] = useState(null);
  const [errors, setErrors] = useState({});
  const [statusList, setStatusList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [showMore, setShowMore] = useState(false); // this state manages the "View More" functionality to expand/collapse additional buttons
  const [showCandidateDetails, setShowCandidateDetails] = useState(false);
  const [showPositionDetails, setShowPositionDetails] = useState(false);
  //   const [showResume, setShowResume] = useState(false);
  const [showInterviewerDetails, setShowInterviewerDetails] = useState(false);
  const [resumeUrl, setResumeUrl] = useState("");
  const [showResume, setShowResume] = useState(false);
  useEffect(() => {
    const fetchInterviewSheet = async () => {
      try {
        if (!InterviewUID) {
          throw new Error("Missing interview code or UID.");
        }

        const response = await GetInterviewSheet(InterviewUID);

        if (response) {
          setCandidateDetails(response.data.candidateDetails);
          setjobDetails(response.data.jobDetails);
          setinterviewerDetails(response.data.interviewerDetails);
          setQuestions(response.data.interviewQuestions);
        }
      } catch (error) {
        const safeMessage =
          error?.response?.data?.message ||
          "Something went wrong. Please try again.";
        setAlert({
          type: "fail",
          message: safeMessage,
        });
        navigate(`/Interview-Assessment/${InterviewUID}`, { replace: true });
      } finally {
      }
    };
    const fetchInterviewConclusionStatus = async () => {
      try {
        const Response = await GetConclusionStatus(InterviewUID);
        setStatusList(Response.data.allStatus || []);
      } catch (err) {
        const safeMessage =
          err.response?.data?.message ||
          "Something went wrong. Please try again.";

        setAlert({
          type: "fail",
          message: safeMessage,
        });
      }
    };
    fetchInterviewSheet();
    fetchInterviewConclusionStatus();
  }, [InterviewUID, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
  };
  const today = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const closeModal = () => {
    setShowModal(false);
  };

  const SkipFeedback = () => {
    setShowModal(true);
  };

  const showResumeModal = () => {
    setShowResume(true);
  };

  const closeResumeModal = () => {
    setShowResume(false);
  };

  const handleSelect = async () => {
    const newErrors = {};
    if (!selectedStatus || selectedStatus === "") {
      newErrors.selectedStatus =
        "Please select an interview conclusion status.";
    }
    if (!remarks || !remarks.toString().trim()) {
      newErrors.remarks = "Please enter interview remarks.";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setAlert({
        type: "fail",
        message: newErrors.selectedStatus || newErrors.remarks,
      });

      if (newErrors.selectedStatus) {
        const sel = document.querySelector(".modal select");
        if (sel) sel.focus();
      } else if (newErrors.remarks) {
        document.getElementById("remarks")?.focus();
      }
      return;
    }

    setAlert(null);
    setErrors({});

    const responseArray = Object.entries(responses).map(([id, data]) => ({
      QuestionID: parseInt(id),
      ...data,
    }));
    try {
      const response = await SubmitInterviewSheet(
        InterviewUID,
        selectedStatus,
        remarks,
        responseArray
      );
      if (response) {
        setAlert({
          type: "success",
          message: response.data.message || "Submited Successfully.",
        });
        setTimeout(() => {
          navigate("/");
        }, 1500);
      }
    } catch (error) {
      const safeMessage =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";

      setAlert({
        type: "fail",
        message: safeMessage,
      });
    }
    closeModal();
  };
  const handleCodeSubmit = async (e) => {
    e.preventDefault();
    try {
      if (enteredCode.trim() !== "") {
        const response = await GetInterviewSheet(InterviewUID, enteredCode);
        if (response) {
          setCandidateDetails(response.data.candidateDetails);
          setjobDetails(response.data.jobDetails);
          setinterviewerDetails(response.data.interviewerDetails);
          navigate(`/Interview-Assessment/${InterviewUID}/${enteredCode}`);
        }
      }
    } catch (error) {
      setAlert({
        type: "fail",
        message: error?.response?.data?.message || "Server error occurred.",
      });
    }
  };
  const handleChange = (id, value, type) => {
    setResponses((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [type]: value,
      },
    }));
  };
  const renderQuestion = (question, index) => {
    const { id, question: qText, description, questionType } = question;
    const response = responses[id] || {};

    switch (questionType) {
      case 1:
        return (
          <>
            <div className="competency-item mb-4">
              <div className="competency-name fw-bold">{qText}</div>
              <div className="competency-description small text-muted mb-2">
                {description}
              </div>
              {errors[id] && (
                <div className="text-danger small mb-2">{errors[id]}</div>
              )}
              <div className="d-flex gap-3 mb-2 align-items-center">
                <label>
                  <input
                    type="radio"
                    name={`yesno-${id}`}
                    value="1"
                    checked={response.Rating === "1"}
                    onChange={(e) => handleChange(id, e.target.value, "Rating")}
                  />
                  <span className="ms-1">Yes</span>
                </label>
                <label>
                  <input
                    type="radio"
                    name={`yesno-${id}`}
                    value="0"
                    checked={response.Rating === "0"}
                    onChange={(e) => handleChange(id, e.target.value, "Rating")}
                  />

                  <span className="ms-1">No</span>
                </label>
              </div>

              {response.Rating === "1" && (
                <>
                  <label className="form-label small text-secondary">
                    Remark
                  </label>
                  <textarea
                    className="form-control"
                    placeholder="Please provide details..."
                    value={response.Remark || ""}
                    onChange={(e) => handleChange(id, e.target.value, "Remark")}
                  />
                </>
              )}
            </div>
          </>
        );

      case 2:
        return (
          <>
            <div className="competency-item mb-4">
              <div className="competency-name fw-bold">{qText}</div>
              <div className="competency-description small text-muted mb-2">
                {description}
              </div>
              {errors[id] && (
                <div className="text-danger small mb-2">{errors[id]}</div>
              )}
              <div
                className="rating-stars d-flex gap-1 mb-2"
                role="radiogroup"
                aria-label={`Rating for ${qText}`}
              >
                {["1", "2", "3", "4"].map((num) => (
                  <span
                    key={num}
                    role="radio"
                    aria-checked={response.Rating === num}
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleChange(id, num, "Rating");
                    }}
                    className="star"
                    onClick={() => handleChange(id, num, "Rating")}
                    style={{
                      cursor: "pointer",
                      color: response.Rating >= num ? "#ffc107" : "#dee2e6",
                      fontSize: "24px",
                    }}
                  >
                    ★
                  </span>
                ))}
              </div>

              {response.Rating && (
                <>
                  <label className="form-label small text-secondary">
                    Remark
                  </label>
                  <textarea
                    className="form-control"
                    placeholder="remark on rating..."
                    value={response.Remark || ""}
                    onChange={(e) => handleChange(id, e.target.value, "Remark")}
                  />
                </>
              )}
            </div>
          </>
        );

      case 3:
      case 4:
        return (
          <>
            <div className="competency-item mb-4">
              <div className="competency-name fw-bold">{qText}</div>
              <div className="competency-description small text-muted mb-2">
                {description}
              </div>
              {errors[id] && (
                <div className="text-danger small mb-2">{errors[id]}</div>
              )}
              <label className="form-label small text-secondary">Remark</label>
              <textarea
                className="form-control"
                placeholder="Your remark"
                value={response.Remark || ""}
                onChange={(e) => handleChange(id, e.target.value, "Remark")}
              />
            </div>
          </>
        );

      default:
        return null;
    }
  };

  const handleResumeClick = async () => {
    try {
      if (!candidateDetails?.resumePath) {
        setAlert({
          type: "fail",
          message: "Resume not available.",
        });
        return;
      }

      const resumeFileName = candidateDetails.resumePath.split("/").pop();

      const response = await GetInterviewResume(resumeFileName, InterviewUID);

      // Create blob URL
      const pdfBlob = new Blob([response.data], {
        type: "application/pdf",
      });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      setResumeUrl(pdfUrl);
      setShowResume(true);
    } catch (error) {
      setAlert({
        type: "fail",
        message: error?.response?.data?.message || "Unable to load resume.",
      });
    }
  };

  return (
    <>
      {candidateDetails ? (
        <>
          <div className="container py-4">
            <div className="row justify-content-center flex-column align-items-center">
              {/* interview assesment form */}
              <div className="col-lg-10 col-xl-12 rounded-1">
                {/* ineterview assessment */}
                <div className="card fade-in border border-top-3">
                  <div className="row card-body justify-content-center m-0 p-0">
                    <div className="candidate-header bg-primary text-white text-center p-3 shadow-sm">
                      <h2>Interview Assessment Form</h2>
                    </div>
                    <div className="candidate-header-rev bg-primary text-white text-center p-3 sticky-top">
                      <div className="row">
                        <div className="col-md-3 mb-2">
                          <p className="mb-0">
                            Candidate: <strong>{candidateDetails.name}</strong>
                          </p>
                        </div>
                        <div className="col-md-3 mb-2">
                          <p className="mb-0">
                            Job Title: <strong>{jobDetails.jobTitel}</strong>
                          </p>
                        </div>
                        <div className="col-md-3 mb-2">
                          <p className="mb-0">
                            Location: <strong>{jobDetails.location}</strong>
                          </p>
                        </div>
                        <div className="col-md-3 mb-2">
                          <p className="mb-0">
                            Date: <strong>{today}</strong>
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="p-md-5 pt-3 px-3">
                      {/* Candidate dwails */}
                      <div className="mb-4">
                        <div className="mb-2">
                          <h4
                            className="section-title mb-2 justify-content-between"
                            onClick={() =>
                              setShowCandidateDetails(!showCandidateDetails)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <div>
                              <i className="bi bi-person-vcard-fill me-2"></i>
                              Candidate Details
                            </div>
                            {/* arrow icon below  */}
                            <div>
                              {showCandidateDetails ? (
                                <i className="bi bi-caret-up-fill"></i>
                              ) : (
                                <i className="bi bi-caret-down-fill"></i>
                              )}
                            </div>
                          </h4>
                        </div>
                        {/* card body */}
                        <div
                          className={`collapsible-section ${
                            showCandidateDetails ? "show" : ""
                          }`}
                        >
                          <div className="card-body">
                            <div className="mb-3 px-1">
                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-person-circle me-2 text-primary fs-5"></i>
                                    Candidate Name :
                                  </label>
                                  <input
                                    type="text"
                                    placeholder="Candidate Name"
                                    className="form-control-plaintext"
                                    value={candidateDetails.name}
                                  />
                                </div>

                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-envelope-fill text-primary fs-5 me-2"></i>
                                    Email :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.email}
                                    readonly="true"
                                  />
                                </div>
                              </div>

                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-calendar2 text-primary fs-5 me-2"></i>
                                    Date of Birth :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.dateOfBirth}
                                    readonly="true"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-phone text-primary fs-5 me-2"></i>
                                    Mobile Number :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.mobile}
                                    readonly="true"
                                  />
                                </div>
                              </div>
                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-geo text-primary fs-5 me-2"></i>
                                    Current Location :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.currentLocation}
                                    readonly="true"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-cash-coin text-primary fs-5 me-2"></i>
                                    Expected CTC :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.expectedCTC}
                                    readonly="true"
                                  />
                                </div>
                              </div>
                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-lightbulb-fill text-primary fs-5 me-2"></i>
                                    Total Experience :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.totalExperience}
                                    readonly="true"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-hourglass-split text-primary fs-5 me-2"></i>
                                    Notice Period :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.noticePeriod}
                                    readonly="true"
                                  />
                                </div>
                              </div>
                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <svg
                                      className="text-primary"
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 640 640"
                                      style={{
                                        width: "1.5em",
                                        height: "1.5em",
                                        fill: "currentColor",
                                        verticalAlign: "-0.15em",
                                        marginRight: "0.25em",
                                      }}
                                    >
                                      {/* <!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--> */}
                                      <path d="M576 160C576 210.2 516.9 285.1 491.4 315C487.6 319.4 482 321.1 476.9 320L384 320C366.3 320 352 334.3 352 352C352 369.7 366.3 384 384 384L480 384C533 384 576 427 576 480C576 533 533 576 480 576L203.6 576C212.3 566.1 222.9 553.4 233.6 539.2C239.9 530.8 246.4 521.6 252.6 512L480 512C497.7 512 512 497.7 512 480C512 462.3 497.7 448 480 448L384 448C331 448 288 405 288 352C288 299 331 256 384 256L423.8 256C402.8 224.5 384 188.3 384 160C384 107 427 64 480 64C533 64 576 107 576 160zM181.1 553.1C177.3 557.4 173.9 561.2 171 564.4L169.2 566.4L169 566.2C163 570.8 154.4 570.2 149 564.4C123.8 537 64 466.5 64 416C64 363 107 320 160 320C213 320 256 363 256 416C256 446 234.9 483 212.5 513.9C201.8 528.6 190.8 541.9 181.7 552.4L181.1 553.1zM192 416C192 398.3 177.7 384 160 384C142.3 384 128 398.3 128 416C128 433.7 142.3 448 160 448C177.7 448 192 433.7 192 416zM480 192C497.7 192 512 177.7 512 160C512 142.3 497.7 128 480 128C462.3 128 448 142.3 448 160C448 177.7 462.3 192 480 192z" />
                                    </svg>
                                    Ready to Relocate :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.readytoRelocate}
                                    readonly="true"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-door-open-fill text-primary fs-5 me-2"></i>
                                    reasonofLeaving :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.reasonofLeaving}
                                    readonly="true"
                                  />
                                </div>
                              </div>
                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    <i className="bi bi-pencil-fill text-primary fs-5 me-2"></i>
                                    Remarks :
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={candidateDetails.remarks}
                                    readonly="true"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* POSITION DETAILS */}
                      <div className="mb-4">
                        <div className="mb-2">
                          <h4
                            className="section-title mb-2 justify-content-between"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              setShowPositionDetails(!showPositionDetails)
                            }
                          >
                            <div>
                              <i className="bi bi-info-circle me-2"></i>
                              Position Details
                            </div>
                            {/* arrow icon below  */}
                            <div>
                              {showPositionDetails ? (
                                <i className="bi bi-caret-up-fill"></i>
                              ) : (
                                <i className="bi bi-caret-down-fill"></i>
                              )}
                            </div>
                          </h4>
                        </div>
                        <div
                          className={`collapsible-section ${
                            showPositionDetails ? "show" : ""
                          }`}
                        >
                          <div className="card-body">
                            <div className="mb-3">
                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Job Title
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={jobDetails.jobTitel}
                                    readonly="true"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Department
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={jobDetails.department}
                                    readonly="true"
                                  />
                                </div>
                              </div>

                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">Location</label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={jobDetails.location}
                                    readonly="true"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Zone</label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={jobDetails.zone}
                                    readonly="true"
                                  />
                                </div>
                              </div>
                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Function Name
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={jobDetails.functionName}
                                    readonly="true"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Gender Preference
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={jobDetails.genderPreference}
                                    readonly="true"
                                  />
                                </div>
                              </div>
                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">Grade</label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={jobDetails.grade}
                                    readonly="true"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    offeredSalary
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={jobDetails.offeredSalary}
                                    readonly="true"
                                  />
                                </div>
                              </div>
                              <div className="row info-row">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Minimum Qualification
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control-plaintext"
                                    value={jobDetails.genderPreference}
                                    readonly="true"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Interviewer Details */}
                      <div className="mb-4">
                        <h4
                          className="section-title justify-content-between"
                          onClick={() =>
                            setShowInterviewerDetails(!showInterviewerDetails)
                          }
                          style={{ cursor: "pointer" }}
                        >
                          <div>
                            <i className="bi bi-building me-2"></i>Interviewer
                            Details
                          </div>
                          {/* arrow icon below  */}
                          <div>
                            {showInterviewerDetails ? (
                              <i className="bi bi-caret-up-fill"></i>
                            ) : (
                              <i className="bi bi-caret-down-fill"></i>
                            )}
                          </div>
                        </h4>
                        <div
                          className={`collapsible-section ${
                            showInterviewerDetails ? "show" : ""
                          }`}
                        >
                          <div className="row info-row">
                            <div className="col-md-6">
                              <label className="form-label">
                                Employee Code
                              </label>
                              <input
                                type="text"
                                className="form-control-plaintext"
                                value={interviewerDetails.employeeCode}
                                readonly="true"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label">Full Name</label>
                              <input
                                type="text"
                                className="form-control-plaintext"
                                value={interviewerDetails.fullName}
                                readonly="true"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Interview Questions */}
                      <h4 className="section-title justify-content-between shadow-none border-0 py-0 my-0">
                        <div>
                          <svg
                            className="me-2"
                            width="32"
                            height="32"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {/* <!-- Speech bubble path --> */}
                            <path
                              d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
                              stroke="#3B82F6"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            ></path>
                            {/* <!-- Heart inside speech bubble --> */}
                            <path
                              d="M12 13.5C12 13.5 8.5 11 8.5 8.5C8.5 7.5 9.5 6.5 10.5 6.5C11.5 6.5 12 7.5 12 7.5S12.5 6.5 13.5 6.5C14.5 6.5 15.5 7.5 15.5 8.5C15.5 11 12 13.5 12 13.5Z"
                              fill="#EF4444"
                              stroke="#EF4444"
                              stroke-width="1"
                            ></path>
                          </svg>
                          FeedBack
                        </div>
                        {/* Skip button to skip the feeback and open model */}
                      </h4>
                      <div className="text-end">
                        <span
                          className="text-primary text-decoration-underline fs-6"
                          style={{ cursor: "pointer" }}
                          onClick={SkipFeedback}
                        >
                          Skip Feedback
                        </span>
                      </div>

                      {questions.length > 0 ? (
                        (() => {
                          const renderedSections = new Set();

                          // Define section headers and icons by questionType
                          const sectionHeaders = {
                            1: {
                              title: "worked with Generali Central",
                              icon: "bi-buildings-fill",
                            },
                            2: { title: "Competencies", icon: "bi-lightbulb" },
                            3: {
                              title: "Sales Commitment Sheet",
                              icon: "bi-receipt",
                            },
                            4: { title: "Role Dimension", icon: "bi-receipt" },
                            // Add more types if needed
                          };

                          return questions.map((question, index) => {
                            const { questionType } = question;
                            const shouldRenderHeader =
                              !renderedSections.has(questionType);

                            if (shouldRenderHeader) {
                              renderedSections.add(questionType);
                            }

                            return (
                              <div
                                key={question.id}
                                style={{ marginBottom: "20px" }}
                              >
                                {shouldRenderHeader &&
                                  sectionHeaders[questionType] && (
                                    <h2
                                      className="section-title shadow-none border-0"
                                      style={{
                                        fontSize: "1.2rem",
                                        fontWeight: "500",
                                      }}
                                    >
                                      -{" "}
                                      <i
                                        className={`bi ${sectionHeaders[questionType].icon}`}
                                      ></i>{" "}
                                      {sectionHeaders[questionType].title}
                                    </h2>
                                  )}
                                {renderQuestion(question, index)}
                              </div>
                            );
                          });
                        })()
                      ) : (
                        <p>Loading questions...</p>
                      )}

                      <div className="text-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary submit-btn mb-3"
                          onClick={handleSubmit}
                        >
                          Submit Assessment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* // Model after the submission */}
          {showModal && (
            <>
              {/* backdrop */}
              <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1040 }}
                onClick={closeModal}
              />

              <div
                className="modal fade show"
                tabIndex={-1}
                role="dialog"
                style={{ display: "block", zIndex: 1050 }}
                aria-modal="true"
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header bg-primary text-white">
                      <h5 className="modal-title">Interview Decision</h5>
                      <button
                        type="button"
                        className="btn-close btn-close-white"
                        aria-label="Close"
                        onClick={closeModal}
                      />
                    </div>

                    <div className="modal-body">
                      <div className="mb-4">
                        <h6 className="text-primary mb-3 form-label fw-bold d-flex">
                          {/* // "color: red; display: block; line-height: 1;" */}
                          Interview Conclusion
                          <span className="text-danger d-block lh-1">*</span>
                          &nbsp;:&nbsp;
                        </h6>
                        <div className="bg-light p-3 rounded">
                          <div className="row">
                            <div className="mb-3">
                              <select
                                className="form-select"
                                value={selectedStatus}
                                onChange={(e) =>
                                  setSelectedStatus(e.target.value)
                                }
                              >
                                <option value="">-- Select Status --</option>
                                {statusList.map((item) => (
                                  <option
                                    key={item.statusID}
                                    value={item.statusID}
                                  >
                                    {item.status}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>

                          <hr />
                          <div className="text-center"></div>
                        </div>
                      </div>

                      <div className="mb-4">
                        <label
                          htmlFor="remarks"
                          className="form-label fw-bold text-primary d-flex"
                        >
                          Interview Remarks
                          <span className="text-danger d-block lh-1">*</span>
                          &nbsp;:
                        </label>

                        <textarea
                          className="form-control"
                          id="remarks"
                          rows="4"
                          placeholder="Enter your remarks about the candidate."
                          value={remarks}
                          onChange={(e) => setRemarks(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="modal-footer justify-content-end">
                      <button
                        type="button"
                        className="btn btn-primary px-5"
                        id="selectBtn"
                        onClick={handleSelect}
                      >
                        Finish
                      </button>
                      <button
                        type="button"
                        className="btn btn-light"
                        aria-label="Close"
                        onClick={closeModal}
                      >
                        cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {showResume && (
            <>
              {/* backdrop */}
              <div
                className="modal-backdrop fade show"
                style={{ zIndex: 1040 }}
              />

              <div
                className="modal fade show"
                tabIndex={-1}
                role="dialog"
                style={{ display: "block", zIndex: 1050 }}
                aria-modal="true"
              >
                <div className="modal-dialog modal-lg" role="document">
                  <div className="modal-content">
                    <div className="modal-header bg-primary text-white justify-content-center">
                      <h5 className="modal-title">
                        <span className="text-center">Candidate Resume</span>
                      </h5>
                      <button
                        type="button"
                        className="btn-close btn-close-white"
                        aria-label="Close"
                        onClick={closeResumeModal}
                      />
                    </div>

                    <div className="modal-body">
                      <div className="mb-3">
                        <div className="row info-row">
                          <div className="col-12">
                            <label className="form-label">Resume</label>
                            <input
                              type="text"
                              className="form-control-plaintext"
                              value={candidateDetails.resumePath}
                              readonly="true"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light"
                        aria-label="Close"
                        onClick={closeResumeModal}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Show iframe if resumeUrl is set */}
          {/* Resume Icon */}
          <div className="resume-icon shadow-lg" onClick={handleResumeClick}>
            <i className="bi bi-file-earmark-text fs-2"></i>
          </div>

          {/* Resume Modal */}
          <Modal
            show={showResume}
            onHide={() => setShowResume(false)}
            size="xl"
            centered
            backdrop="static"
          >
            <Modal.Header closeButton>
              <Modal.Title>Candidate Resume</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: "80vh" }}>
              {resumeUrl && (
                <iframe
                  src={resumeUrl}
                  title="Candidate Resume"
                  width="100%"
                  height="100%"
                  style={{ border: "1px solid #ccc", borderRadius: "5px" }}
                ></iframe>
              )}
            </Modal.Body>
          </Modal>

          {/* <!-- Resume Icon --> */}
          <div className="resume-icon shadow-lg" onClick={handleResumeClick}>
            <i className="bi bi-file-earmark-text fs-2"></i>
          </div>
        </>
      ) : (
        <></>
      )}
      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
    </>
  );
};

export default InterviewAssesment;
